<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="8">
                <v-text-field
                  v-model.trim="unidad.nombre"
                  label="* Nombre de la unidad"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model.trim="unidad.codigo"
                  label="* Codigo de unidad"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="unidad.descripcion"
                  label="Descripcion de la unidad"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model.trim="unidad.email"
                  label="Email de la unidad"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model.trim="unidad.sitio_web"
                  label="Sitio web de la unidad"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <div>
              <v-divider></v-divider>
              <span>Agregar conceptos de pago:</span>
              <v-btn class="mx-2" :disabled="disableconceptos()" small dark color="green" @click="setconcepto(true)">
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
              <v-btn class="mx-2" small dark color="red" @click="setconcepto(false)">
                <v-icon dark> mdi-minus </v-icon>
              </v-btn>

              <div v-for="(c, ind) in conceptos" :key="ind">
                <v-select
                  class="mt-4"
                  outlined
                  dense
                  return-object
                  v-model="c.concepto"
                  :prefix="ind + 1 + '.- '"
                  placeholder="Seleccione un concepto"
                  :items="xconceptos"
                  item-text="nombre"
                ></v-select>
              </div>
            </div>

            <div>
              <v-divider></v-divider>
              <span>Agregar categorias:</span>
              <v-btn class="mx-2" :disabled="disablecates()" small dark color="green" @click="setxcategorias(true)">
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
              <v-btn class="mx-2" small dark color="red" @click="setxcategorias(false)">
                <v-icon dark> mdi-minus </v-icon>
              </v-btn>

              <div v-for="(c, ind) in xcategorias" :key="ind">
                <v-row>
                  <v-col>
                    <v-text-field v-model.trim="c.nombre" label="* Nombre:" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model.trim="c.descripcion"
                      label="Descripcion:"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-select
                  class="mt-4"
                  outlined
                  dense
                  return-object
                  :prefix="ind + 1 + '.- '"
                  placeholder="Seleccione una categoria"
                  v-model="c.categoria"
                  :items="categorias"
                ></v-select> -->
              </div>
            </div>
          </v-container>

          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-3" class="white--text" @click="dialog = !dialog">
            Cerrar
          </v-btn>
          <v-btn color="green darken-3" :disabled="loading || exitoso" class="white--text" @click="save">
            {{ unidad.id ? 'Actualizar' : 'Guardar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <AXprogramautils ref="axprogramautils" />
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import AXprogramautils from '@/components/AXprogramautils.vue';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      exitoso: false,
      msg: '',
      unidad: {
        id: null,
        nombre: null, //
        codigo: null, //
        descripcion: null,
        email: null,
        sitio_web: null,
      },
      conceptos: [],
      xconceptos: [],
      categorias: [],
      xcategorias: [],
    }),

    computed: {
      formTitle() {
        return this.unidad.id ? 'Editar Unidad' : 'Registrar nueva unidad';
      },
    },

    components: { AXprogramautils },

    methods: {
      openmodal(item) {
        this.loading = false;
        this.exitoso = false;
        this.dialog = true;
        this.unidad.id = null;
        this.unidad.nombre = null;
        this.unidad.codigo = null;
        this.unidad.descripcion = null;
        this.unidad.email = null;
        this.unidad.sitio_web = null;
        this.conceptos = [];
        this.xcategorias = [];
        this.msg = '';
        if (item) this.getitem(item);
      },
      setconcepto(add) {
        if (!add) this.conceptos.pop();
        else {
          this.conceptos.push({ concepto: null });
        }
      },
      setxcategorias(add) {
        if (!add) this.xcategorias.pop();
        else {
          this.xcategorias.push({ nombre: null, descripcion: null });
        }
      },
      getconceptos() {
        const vue = this;
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let urlc = `${process.env.VUE_APP_API_REST}/api/pagos/conceptos/buscar`;
        let raw = JSON.stringify({ unidad_negocio_id: unidad });
        const promise1 = xaxios.post(urlc, raw);
        this.$refs.axprogramautils.getCategorias(this);

        Promise.all([promise1]).then(function(values) {
          //window.console.log('>', values);
          vue.xconceptos = values[0].data;
        });
      },
      disablecates() {
        return this.xcategorias.length >= this.categorias.length;
      },
      disableconceptos() {
        return this.conceptos.length >= this.xconceptos.length;
      },
      getitem(item) {
        window.console.log(item);
        const vue = this;
        let urlc = `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadnegocio/${item.id}`;
        const promise1 = xaxios.get(urlc);
        this.$refs.axprogramautils.getCategorias(this);

        Promise.all([promise1]).then(function(values) {
          let data0 = values[0].data;
          window.console.log('>>', data0);
          vue.unidad.id = data0.id;
          vue.unidad.nombre = data0.nombre;
          vue.unidad.codigo = data0.codigo;
          vue.unidad.descripcion = data0.descripcion;
          vue.unidad.email = data0.email;
          vue.unidad.sitio_web = data0.sitio_web;
        });
      },
      async save() {
        this.msg = '';
        if (!this.unidad.codigo) this.msg = 'Complete el codigo de la unidad';
        if (!this.unidad.nombre) this.msg = 'Complete el nombre de la unidad';
        let tamnom = this.unidad.nombre && this.unidad.nombre.length;
        let tamcod = this.unidad.codigo && this.unidad.codigo.length;
        let desval = this.unidad.descripcion && this.unidad.descripcion.length > 1000;
        let emailval = this.unidad.email && this.unidad.email.length > 150;
        let webval = this.unidad.sitio_web && this.unidad.sitio_web.length > 200;
        if (tamnom < 3 || tamnom > 150) this.msg = 'El nombre debe estar entre 3 y 150 caracteres.';
        if (tamcod < 3 || tamcod > 20) this.msg = 'El codigo debe estar entre 3 y 20 caracteres.';
        if (desval) this.msg = 'La descripcion debe ser menor a 1000 caracteres';
        if (emailval) this.msg = 'El email debe ser menor a 150 caracteres';
        if (webval) this.msg = 'El sitio web debe ser menor a 200 caracteres';

        let ids_categorias = this.xcategorias;
        let ids_conceptos = this.conceptos.map((x) => {
          if (!x.concepto) x.concepto = {};
          return { concepto_id: x.concepto.id };
        });
        let findDuplicates = (arr) => arr.filter((item, index) => arr.indexOf(item) != index);
        let cates_duplicadas = findDuplicates(ids_categorias);
        let conce_duplicados = findDuplicates(ids_conceptos);
        if (cates_duplicadas.length > 0) this.msg = 'Error existen categorias duplicadas.';
        if (conce_duplicados.length > 0) this.msg = 'Error existen conceptos duplicados.';
        if (this.msg) return;
        this.loading = true;

        let data = JSON.stringify({
          id: this.unidad.id,
          nombre: this.unidad.nombre,
          codigo: this.unidad.codigo,
          descripcion: this.unidad.descripcion,
          email: this.unidad.email,
          sitio_web: this.unidad.sitio_web,
          conceptos: ids_conceptos,
          categorias: ids_categorias,
        });

        window.console.log(data);
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadnegocio`;
        let metodo = 'post';
        if (this.unidad.id) metodo = 'put';
        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        };

        await xaxios.request(config)
          .then(({ data }) => {
            window.console.log(data, vue);
            vue.msg = data.data;
            vue.loading = false;
            vue.exitoso = true;
            vue.$emit('onnewreg');
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading = false;
          });
      },
    },
    mounted() {
      this.getconceptos();
    },
  };
</script>
